/*!
 * Custom configuration settings for slxControls.
 *
 * Dependencies: jQuery v1.10+
 */
(function (x) {
    'use strict';
    var x = window.SlxControl;

    // apply all custom config settings here
    x(function () {
        x.slx.scriptpath = (window.__applicationRoot || (selerix || {}).applicationRoot || '') + 'selerix_common/lib/slxcontrols/';
        x.slx.config = {
            icon: {
                danger: 'glyphicons glyphicons-exclamation-sign',
                warning: 'glyphicons glyphicons-warning-sign',
                info: 'glyphicons glyphicons-circle-info',
                success: 'halflings halflings-ok',
                'default': 'halflings halflings-ok'
            },
            bootstrap: 3
        };
    });

    return x;
})();